<template>
  <div v-if="ysaAvailable">
    <div class="chat-section__container">
      <div class="chat-section__content">
        <h2 class="chat-section__heading">
          {{ tr("client.chat.chat_section_heading") }}
        </h2>
        <p class="chat-section__description">
          {{ tr("client.chat.chat_section_description") }}
        </p>
      </div>
      <SButton
        action-type="primary"
        class="chat-section__button"
        color="primary"
        prefix-icon="fa-regular fa-messages"
        size="sm"
        @click="ysaToggle"
      >
        {{ tr("client.chat.chat_section_button") }}
      </SButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SButton } from "@solvari/common-fe";
import { useYouShouldAsk } from "@solvari/components";
import { useI18nMainSite } from "@solvari/translations";

const props = defineProps<{
  websiteType?: "mainSite" | "mySolvari";
}>();

const { ysaToggle, ysaAvailable } = useYouShouldAsk(props.websiteType);
const { tr } = useI18nMainSite();
</script>

<style lang="postcss">
.chat-section {
  @apply w-full bg-slate-50;

  &__container {
    @apply flex flex-col items-center px-4 py-8 gap-6;
  }

  &__content {
    @apply flex flex-col items-center gap-2;
  }

  &__heading {
    @apply m-0 max-w-[896px] text-center text-xl font-extrabold leading-7 text-slate-700;
  }

  &__description {
    @apply m-0 text-center text-base font-medium leading-6 text-slate-700;
  }
}

@screen 1000 {
  .chat-section {
    &__container {
      @apply py-16 gap-6;
    }

    &__heading {
      @apply text-4xl leading-10;
    }

    &__description {
      @apply text-lg font-normal leading-7;
    }
  }
}
</style>
